import { Box, Button } from '@chakra-ui/react';
import { SyntheticEvent } from 'react';
import { useUITranslation } from '../../context/TranslationProvider';

type Props = {
  handleClose: (e: SyntheticEvent, shouldClear?: boolean) => void;
};

const DatePickerFooter: React.FC<Props> = ({ handleClose }) => {
  const { t } = useUITranslation();

  return (
    <Box display={{ md: 'none' }}>
      <Button
        mt="space.16"
        mb="space.8"
        float="left"
        variant="light"
        width={100}
        onClick={e => {
          handleClose(e, true);
        }}
      >
        {t('cancel')}
      </Button>
      <Button
        mt="space.16"
        mb="space.8"
        float="right"
        variant="primary"
        width={100}
        onClick={e => {
          handleClose(e);
        }}
      >
        {t('done')}
      </Button>
    </Box>
  );
};

export default DatePickerFooter;
